module.exports = __webpack_public_path__ + "img/minus.464bfac0.svg";